import image1 from '@/assets/images/news/detail/20200801/1.jpg';
import image2 from '@/assets/images/news/detail/20200801/2.jpg';
import image3 from '@/assets/images/news/detail/20200801/3.png';
import image4 from '@/assets/images/news/detail/20200801/4.png';
import image5 from '@/assets/images/news/detail/20200801/5.png';
import image6 from '@/assets/images/news/detail/20200801/6.png';
import image7 from '@/assets/images/news/detail/20200801/7.png';

export default {
  id: '20200801', //  模块 id
  title: '退伍不褪色 叮咚显本色', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text:
        '在叮咚，有这么一群人，他们曾是沙场的战士，也是岗位的尖兵。在离开部队后，他们将军人的精神带到叮咚，在各自的岗位上继续发光发热。在今年八一建军节来临之际，我们采访到几名曾有军旅经历的小伙伴，一起来听一听他们的故事。',
      isIndent: false,
    },
    {
      type: 1,
      title: [
        '李智 上海事业部/江桥区域/爱特服务站 仓管员',
        '2010年底参军，在野战部队服役5年',
      ],
      src: [image1, image2],
    },
    {
      type: 0,
      text:
        '他说：“服役期间，一年有八个月在野外驻训，环境艰苦，后勤保障较少，锤炼出了吃苦耐劳、敢拼敢闯的人民子弟兵精神。入职叮咚买菜以来，在盘货的过程中，有种在与站内商品为敌的感觉，既要保证它们品质确定、数量准确，又要对品质不好的商品坚决消灭。希望自己继续立足现有岗位做好做精，做好企业机器运行的螺丝钉。”',
      isIndent: false,
    },
    {
      type: 1,
      title: [
        '刘国民 深圳城市分选中心/良白路冷冻仓 仓储组长',
        '2001-2006年服役于西藏军区和成都军区某部',
      ],
      src: [image3, image4],
    },
    {
      type: 0,
      text:
        '他说：“军旅生涯教会我更注重团队合作，练就坚韧的信念和意志。我刚进叮咚就能隐约感到公司有着部队的某些特质，是前辈们军人般百折不挠的精神开创了叮咚。市场竞争如此激烈，我们叮咚人凭什么能比别人做得好、做得大、做得强，我们拼的是特别能吃苦的传统、特别能战斗的能力、特别能团结的氛围、特别能奉献的精神，以及百折不挠的信念和最好的服务品质！”',
      isIndent: false,
    },
    {
      type: 1,
      title: [
        '王晨 北京事业部/西城区域/六里桥站 配送员',
        '2015年入伍汽车第十七团【78525部队】 主要负责川藏线运输',
      ],
      src: [image5, image6],
    },
    {
      type: 0,
      text:
        '他说：“那时，我们团一年有八次进藏任务，运送米面粮油、衣物铺盖等物资，八次进藏一次也不能少，因为每少一次，在边疆守卫的战士都有可能面临吃不好穿不暖的现象。然而，每次进藏都会遇到各种问题：车辆抛锚，车辆追尾……这和叮咚配送员的工作很像，送单途中常遇爆胎、大风大雨等突发情况，但这不能阻挡我们按时配送。我们是叮咚铁军，铁一样的团队，铁一样的纪律。不管面临多大的艰辛，我们叮咚铁军都要尽力克服，完美无缺的完成每一个订单，不辜负每一个客户的信任。”',
      isIndent: false,
    },
    {
      type: 1,
      title: ['扫码看更多'],
      isQrcode: true,
      src: [image7],
    },
  ],
};
